export default function ContactFooter() {
  return (
    <footer className="relative w-full bg-foreground-900 px-4 md:px-6 py-16 md:py-20 rounded-t-[2.5rem] mx-auto max-w-[calc(100%-2rem)] md:max-w-[calc(100%-3rem)]">
      <div className="relative z-10 w-full max-w-[1100px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-8">
          <div className="lg:col-span-1">
            <p className="font-heading text-3xl md:text-4xl text-background-50 mb-6 leading-tight">
              Let&rsquo;s build<br />the future.
            </p>
          </div>

          <div className="lg:col-span-1">
            <p className="font-label text-sm font-semibold uppercase tracking-[0.15em] text-background-50 mb-6">
              Engineering
            </p>
            <ul className="space-y-4">
              <li>
                <p className="text-sm text-background-50/60 font-body">System Architecture</p>
              </li>
              <li>
                <p className="text-sm text-background-50/60 font-body">Performance Engineering</p>
              </li>
              <li>
                <p className="text-sm text-background-50/60 font-body">Quality Engineering</p>
              </li>
              <li>
                <p className="text-sm text-background-50/60 font-body">Technical Strategy</p>
              </li>
              <li>
                <p className="text-sm text-background-50/60 font-body">Continuous Innovation</p>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-1">
            <p className="font-label text-sm font-semibold uppercase tracking-[0.15em] text-background-50 mb-6">
              Principles
            </p>
            <ul className="space-y-4">
              <li className="flex items-center gap-3">
                <span className="w-2 h-2 rounded-full bg-primary-500 flex-shrink-0"></span>
                <p className="text-sm text-background-50/60 font-body">Clean Architecture</p>
              </li>
              <li className="flex items-center gap-3">
                <span className="w-2 h-2 rounded-full bg-accent-500 flex-shrink-0"></span>
                <p className="text-sm text-background-50/60 font-body">Usability Focus</p>
              </li>
              <li className="flex items-center gap-3">
                <span className="w-2 h-2 rounded-full bg-secondary-500 flex-shrink-0"></span>
                <p className="text-sm text-background-50/60 font-body">Long-Term Stability</p>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-1">
            <p className="font-label text-sm font-semibold uppercase tracking-[0.15em] text-background-50 mb-2">
              Contact
            </p>
            <p className="text-xs text-background-50/40 font-body mb-6">
              Based in Tallinn, Estonia
            </p>

            <div className="space-y-3">
              <p className="text-sm text-background-50/60 font-body leading-relaxed">
                Paevalille tn 6-15
              </p>
              <p className="text-sm text-background-50/60 font-body leading-relaxed">
                Tallinn, 13517
              </p>
              <p className="text-sm text-background-50/60 font-body leading-relaxed">
                Estonia
              </p>
              <div className="pt-3">
                <p className="text-sm text-background-50/60 font-body leading-relaxed">
                  +372 58989638
                </p>
                <p className="text-sm text-background-50/60 font-body leading-relaxed">
                  ceo@vorteksi.com
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute inset-0 flex items-center justify-center pointer-events-none overflow-hidden rounded-t-[2.5rem]">
        <span className="font-heading text-[18vw] md:text-[14vw] text-background-50/[0.03] select-none whitespace-nowrap leading-none">
          ENGINEERING
        </span>
      </div>
    </footer>
  );
}